import { gql } from '@apollo/client'

export const SelectedQuery = gql`
  query SelectedClientTypeSelector($companyId: ID!, $id: ID) {
    clientTypes(companyId: $companyId, filters: { idEq: $id }) {
      nodes {
        id
        name
      }
    }
  }
`

export const Query = gql`
  query ClientTypeSelector(
    $companyId: ID!,
    $filters: ClientTypeFilters,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    clientTypes(companyId: $companyId, filters: $filters, after: $after, before: $before, first: $first, last: $last) {
      nodes {
        id
        name
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
